import { IMiddleCategoryCropPriceInfo, ISmallCategoryCropPriceInfo } from '../../interfaces/CropTrends.interface';
import { createURLSearchParams } from '../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../common/customAxios';

export interface IGetCropPriceSummaryParams {
  searchParam: {
    wholesaleMarketCode: string;
    largeCategoryCode: string;
    middleCategoryCode: string;
    smallCategoryCode: string;
  };
}

export interface IGetCropPriceSummaryResponse {
  tradeCalculationDate: string;
  categoryName: string;
  todayTradeInfo: {
    averagePrice: number;
    highestPrice: number;
    lowestPrice: number;
    totalQuantity: number;
    totalPrice: number;
  };
  dailyChange: {
    previousPrice: number;
    changeAmount: number;
    changeRate: number;
  };
}

export const getCropPriceSummary = ({
  searchParam,
}: IGetCropPriceSummaryParams): Promise<IGetCropPriceSummaryResponse> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/crops/price-summary?${URLSearchParams}`);
};
